import React from "react";

import useDocumentTitle from "../../hooks/useDocumentTitle";
import ContactForm from "./components/ContactForm";

/**
 * お問い合わせ（/contact）。
 * 入力 → 確認 → 完了 のステップフロー。レイアウトは共通の StepFlowLayout
 * （戻る + 中央ステップナビ / 読み幅の本文 / 同幅のフッター）に載せる。
 */
const Contact: React.FC = () => {
  useDocumentTitle("お問い合わせ");
  return <ContactForm />;
};

export default Contact;
